import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Popover, Checkbox, DatePicker } from 'antd';
import { DATETIME_FORMAT } from '../../constants/grid.constants';
import { OPTIMISE_CONFIRMATION } from '../../constants/text.constants';
import { SubNavButton, OptimisePanelWrapper } from './styles';

class Experimentals extends Component {
  state = {
    visible: false,
    startTime: '',
    usePrevPlan: true,
  };

  handleVisibleChange = (visible) => {
    this.setState({ visible });
  };

  handleClickToHide = () => {
    this.setState({ visible: false });
  }

  handleClickToOptimise = () => {
    this.props.onConfirm(this.state);
    this.handleClickToHide();
  }

  experimentalFeats = () => (
    <OptimisePanelWrapper>
      <small>{OPTIMISE_CONFIRMATION}</small>
      <div>
        Start from:
        <br />
        <DatePicker
          value={this.state.startTime}
          showTime
          autoFocus
          format={DATETIME_FORMAT}
          placeholder={DATETIME_FORMAT}
          onChange={(value) => {
            if (value) {
              this.setState({ startTime: moment(value).tz(this.props.timeZone) });
            } else {
              this.setState({ startTime: '' });
            }
          }}
        />
        <br />
        <small>Leave this empty for full week</small>
      </div>
      <div>
        <Checkbox defaultChecked onChange={(e) => { this.setState({ usePrevPlan: e.target.checked }); }}>
          <small>Consider past optimisation</small>
        </Checkbox>
      </div>
      <div>
        <SubNavButton mr={1} onClick={this.handleClickToHide}>Cancel</SubNavButton>
        <SubNavButton onClick={this.handleClickToOptimise}>Proceed</SubNavButton>
      </div>
    </OptimisePanelWrapper>
  );

  render() {
    return (
      <Popover
        title={`Optimise ${this.props.siteName}`}
        placement="bottomRight"
        trigger="click"
        content={this.experimentalFeats()}
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
      >
        {this.props.children}
      </Popover>
    );
  }
}
export default Experimentals;
